export default {
  namespaced: true,
  state: {
    // 当前激活课程详情的菜单
    courseDetailNavActive: 1,
    // 最近视频小节
    videoSection: {},
    // 视频小节增加时长
    videoStudyTime: {},
    // 帖子列表刷新状态
    postListReload: true,
    // 帖子列表滚动高度
    postListScrollTop: 0,
    // 当前修改的帖子数据
    nowChangePost: {},
    // 课程详情讨论区刷新状态
    courseDetailDiscuss: true,
    // 课程详情列表滚动高度
    courseDetailDiscusTop: 0,
    // 学习足迹的刷新状态
    footprintReload: true,
    footprintScrollTop: 0,
    // 未学课程列表刷新状态
    notLearnedReload: true,
  },
  mutations: {
    // 改变课程详情菜单
    changeNavActive(state, num) {
      state.courseDetailNavActive = num;
    },
    // 切换视频小节
    changeVideoSection(state, data) {
      state.videoSection = data;
    },
    // 增加视频学习时长
    addVideoStudyTime(state, data) {
      state.videoStudyTime = data;
    },
    // 修改帖子列表滚动高度
    setPostListScrollTop(state, data) {
      state.postListReload = data.break;
      state.postListScrollTop = data.top;
    },
    // 设置课程详情讨论区刷新状态
    setCourseDetailDiscuss(state, data) {
      state.courseDetailDiscuss = data.break;
      state.courseDetailDiscusTop = data.top;
    },
    setNowDiscuss(state, data) {
      state.nowChangePost = data;
    },
    // 设置课程详情列表滚动高度
    setCourseDetailDiscusTop(state, num) {
      state.courseDetailDiscusTop = num;
    },
    // 设置学习足迹的刷新滚动
    setFootprintScroll(state, data) {
      state.footprintReload = data.break;
      state.footprintScrollTop = data.top;
    },
    // 设置未学课程列表刷新状态
    setNotLearnedReload(state, blen) {
      state.notLearnedReload = blen;
    },
  },
};
